import { useState, useEffect } from "react";
import { Box, Button, IconButton } from "@mui/material";
import GridIndex from "../../../components/GridIndex";
import { Check, HighlightOff } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CustomModal from "../../../components/CustomModal";
import axios from "../../../services/Api";
import moment from "moment";
import useBreadcrumbs from "../../../hooks/useBreadcrumbs";
import useAlert from "../../../hooks/useAlert";

const userId = JSON.parse(sessionStorage.getItem("AcharyaErpUser"))?.userId;
const roleId = JSON.parse(sessionStorage.getItem("AcharyaErpUser"))?.roleId;
const isAdmin = roleId === 1;
const isPrincipal = roleId === 16;
const isHOD = roleId === 4;
const isAdminOrPrincipal = isAdmin || isPrincipal;
const canCreate = isAdmin || isPrincipal || isHOD;

function CourseAssignmentIndex() {
  const { setAlertMessage, setAlertOpen } = useAlert();
  const [rows, setRows] = useState([]);
  const [modalContent, setModalContent] = useState({
    title: "",
    message: "",
    buttons: [],
  });
  const [modalOpen, setModalOpen] = useState(false);

  const navigate = useNavigate();
  const setCrumbs = useBreadcrumbs();
  const { pathname } = useLocation();
  const columns = [
    { field: "username", headerName: "Faculty", flex: 1 },
    { field: "course_short_name", headerName: "Course", flex: 1 },
    { field: "course_code", headerName: "Course Code", flex: 1 },
    // {
    //   field: "program_short_name",
    //   headerName: "Specialization",
    //   flex: 1,
    //   valueGetter: (value, row) =>
    //     row.program_short_name + "-" + row.program_specialization_short_name,
    // },
    // { field: "ac_year", headerName: "Ac Year", flex: 1 },
    // { field: "year_sem", headerName: "Year/Sem", flex: 1 },
    { field: "empcode", headerName: "Empcode", flex: 1 },
    { field: "duration", headerName: "Vtu Max Hours", flex: 1 },
    // { field: "remarks", headerName: "Remarks", flex: 1 },
    { field: "createdUsername", headerName: "Created By", flex: 1 },
    {
      field: "createdDate",
      headerName: "Created Date",
      flex: 1,
      // type: "date",
      valueGetter: (value, row) => moment(row.createdDate).format("DD-MM-YYYY"),
    },

    // {
    //   field: "id",
    //   type: "actions",
    //   flex: 1,
    //   headerName: "Update",
    //   getActions: (params) => [
    //     <IconButton
    //       onClick={() =>
    //         navigate(
    //           `/TimeTableMaster/CourseAssignment/Update/${params.row.id}`,
    //           { 
    //             state: { 
    //               parent: "ttCourse",
    //               rowData: params.row,
    //             } 
    //           }
    //         )
    //       }
    //     >
    //       <EditIcon />
    //     </IconButton>,
    //   ],
    // },

    {
      field: "active",
      headerName: "Active",
      flex: 1,
      type: "actions",
      getActions: (params) => {
        const isCreator = params.row.createdBy === userId;
        const shouldDisable = !isCreator && !isAdmin;
        const buttonColor = shouldDisable ? "grey" : (params.row.active === true ? "green" : "red");
        
        return [
          params.row.active === true ? (
            <IconButton
              style={{ color: buttonColor }}
              onClick={() => handleActive(params)}
              disabled={shouldDisable}
            >
              <Check />
            </IconButton>
          ) : (
            <IconButton
              style={{ color: buttonColor }}
              onClick={() => handleActive(params)}
              disabled={shouldDisable}
            >
              <HighlightOff />
            </IconButton>
          ),
        ];
      },
    },
  ];

  const getData = async () => {
    await axios
      .get(
        `/api/academic/fetchAllSubjectAssignmentV2?page=${0}&page_size=${1000000}&sort=createdDate`
      )
      .then((res) => {
        setRows(res.data.data.Paginated_data.content);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    getData();
    if (pathname.toLowerCase() === "/courseassignmentindex") {
      setCrumbs([{ name: "Course Assignment" }]);
    }
  }, []);

  const handleActive = async (params) => {
    const userId = params.row.user_id;
    const courseId = params.row.course_id;
    
    if (!userId || !courseId) {
      setAlertMessage({
        severity: "error",
        message: "Missing user_id or course_id. Cannot perform this operation.",
      });
      setAlertOpen(true);
      return;
    }
    
    setModalOpen(true);
    const handleToggle = async () => {
      if (params.row.active === true) {
        axios
          .delete(`/api/academic/inactiveSubjectAssignment?user_id=${userId}&course_id=${courseId}`)
          .then((res) => {
            if (res.status === 200) {
              getData();
              setModalOpen(false);
            }
          })
          .catch((err) => {
            console.error(err);
            setAlertMessage({
              severity: "error",
              message:
                err?.response?.data?.message || "Error deactivating the subject assignment",
            });
            setAlertOpen(true);
            setModalOpen(false);
          });
      } else {
        axios
          .delete(`/api/academic/activateSubjectAssignment?user_id=${userId}&course_id=${courseId}`)
          .then((res) => {
            if (res.status === 200) {
              getData();
              setModalOpen(false);
            }
          })
          .catch((err) => {
            console.error(err);
            setAlertMessage({
              severity: "error",
              message:
                err?.response?.data?.message || "Error activating the subject assignment",
            });
            setAlertOpen(true);
            setModalOpen(false);
          });
      }
    };
    params.row.active === true
      ? setModalContent({
          title: "",
          message: "Do you want to make it Inactive?",
          buttons: [
            { name: "Yes", color: "primary", func: handleToggle },
            { name: "No", color: "primary", func: () => {} },
          ],
        })
      : setModalContent({
          title: "",
          message: "Do you want to make it Active?",
          buttons: [
            { name: "Yes", color: "primary", func: handleToggle },
            { name: "No", color: "primary", func: () => {} },
          ],
        });
    setModalOpen(true);
  };

  return (
    <>
      <CustomModal
        open={modalOpen}
        setOpen={setModalOpen}
        title={modalContent.title}
        message={modalContent.message}
        buttons={modalContent.buttons}
      />
      <Box sx={{ position: "relative", mt: 2 }}>
        {canCreate && (
          <Button
            onClick={() =>
              navigate("/TimeTableMaster/CourseAssignment/New", {
                state: { parent: "ttCourse" },
              })
            }
            variant="contained"
            disableElevation
            sx={{ position: "absolute", right: 0, top: -57, borderRadius: 2 }}
            startIcon={<AddIcon />}
          >
            Create
          </Button>
        )}
        <GridIndex rows={rows} columns={columns} />
      </Box>
    </>
  );
}
export default CourseAssignmentIndex;
